// React and routing imports
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

// Route components
import AuthenticatePublicRoutes from './AuthenticatePublicRoutes';
import UnauthenticatePublicRoutes from './UnauthenticatePublicRoutes';
import AuthPopup from '../components/AuthPopup';
import { showLoginModal } from '../redux/slices/uiSlice';

// Main public routes component - handles route switching based on auth state
const PublicRoutes = () => {
  const dispatch = useDispatch();

  // Get authentication state from Redux
  const token = useSelector((state) => state.auth.token);
  const role = useSelector((state) => state.auth.role);
  const showLogin = useSelector((state) => state.ui.showLoginModal);

  return (
    <>
      {/* Login popup modal */}
      <AuthPopup open={showLogin} onClose={() => dispatch(showLoginModal(false))} />
      <Routes>
        {/* Switch between authenticated and non-authenticated routes */}
        <Route
          path="/*"
          element={token && role === 'client' ? <AuthenticatePublicRoutes /> : <UnauthenticatePublicRoutes />}
        />
      </Routes>
    </>
  );
};

export default PublicRoutes;
